import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Card from "react-bootstrap/Card";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const Cookies = () => {
   const { t, i18n } = useTranslation();
   const basePath = i18n.language === "en" ? "/en" : "";
   const [cookieConsent, setCookieConsent] = useState(null);

   useEffect(() => {
      const cookie = document.cookie
         .split("; ")
         .find((row) => row.startsWith("userCookieConsent="));
      if (cookie) {
         setCookieConsent(cookie.split("=")[1]);
      }
   }, []);

   const updateCookieConsent = (value) => {
      // Obtener la fecha de expiración en GMT
      const maxAge = 15 * 24 * 60 * 60; // 15 días en segundos
      const expires = new Date(Date.now() + maxAge * 1000).toUTCString();

      // Establecer la cookie con todos los atributos importantes
      document.cookie = `userCookieConsent=${value}; expires=${expires}; path=/; SameSite=Lax`;

      // Actualizar el estado de React
      setCookieConsent(value);

      // Opcional: recargar la página para que los vídeos se actualicen automáticamente
      window.location.reload();
   };


   return (
      <div className="policy-conditions">
         <Helmet>
            <title>Política de cookies | Joan Company</title>
            <meta
               name="description"
               content="Información sobre la política de cookies y tratamiento de datos en Joan Company."
            />
            <link
               rel="alternate"
               href="https://www.joancompany.es/cookies"
               hreflang="es"
            />
            <link
               rel="alternate"
               href="https://www.joancompany.es/en/cookies"
               hreflang="en"
            />
         </Helmet>
         <div className="policy-conditions-container">
            <h1>{t("cookies_policy")}</h1>
            <h2>{t("last_update")}</h2>
         </div>
         <div className="page-breadcrumb">
            <Link to={`${basePath}/`} title="Home">
               {t("home")}
            </Link>
            <span>/</span>
            <span>{t("cookies_policy")}</span>
         </div>
         <Card
            className="quote-card-view"
            id="service-info-card"
            data-aos="fade-up"
            data-aos-duration="2000"
         >
            <Card.Body>
               <div className="policy-conditions-content">
                  <div
                     dangerouslySetInnerHTML={{ __html: t("cookies_content") }}
                  />
               </div>
               <div
                  className="cookies-manager-container"
                  style={{ padding: "4vh" }}
               >
                  <h3 style={{ marginInline: "" }}>{t("cookie_p")}</h3>
                  <p>
                     {t("actually_using")}{" "}
                     {cookieConsent === "true"
                        ? t("cookies_accepted")
                        : cookieConsent === "false"
                        ? t("cookies_rejected")
                        : t("not_defined")}
                  </p>
                  <button
                     style={{
                        background: "var(--imp-text-color)",
                        color: "var(--imp-background-light-color)",
                        fontWeight: "bold",
                        fontSize: "14px",
                        borderRadius: "8px",
                        padding: "8px 16px",
                        margin: "0 8px",
                        cursor: "pointer",
                     }}
                     onClick={() => updateCookieConsent("true")}
                  >
                     {t("accept_cookies")}
                  </button>
                  <button
                     style={{
                        background: "transparent",
                        color: "var(--imp-background-light-color)",
                        fontWeight: "bold",
                        fontSize: "14px",
                        borderRadius: "8px",
                        padding: "8px 16px",
                        margin: "0 8px",
                        border: "1px solid var(--imp-background-light-color)",
                        cursor: "pointer",
                     }}
                     onClick={() => updateCookieConsent("false")}
                  >
                     {t("reject_cookies")}
                  </button>
               </div>
            </Card.Body>
         </Card>
      </div>
   );
};

export default Cookies;
